import React from "react";
import { Link } from "react-router-dom";
import { Instagram, MapPin, Phone, Mail, CalendarCheck } from "lucide-react";
import { COMPANY, COPY, FEATURES, waLink } from "@/lib/company";
import { WaIcon } from "@/lib/whatsapp";
import Logo from "@/components/Logo";

const nav = [
  ["/fahrzeuge", "Fahrzeuge"], ...(FEATURES.ankauf ? [["/ankauf", "Fahrzeugankauf"]] : []), ...(FEATURES.findet ? [["/fahrzeugsuche", "Wunschfahrzeug"]] : []),
  ...(FEATURES.financing ? [["/finanzierung", "Finanzierung"]] : []),
  ["/ueber-uns", "Über uns"], ["/kontakt", "Kontakt"],
];

export const Footer = () => (
  <footer data-testid="main-footer" className="bg-deep text-white border-t border-line pb-24 lg:pb-0">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 md:py-24 grid grid-cols-1 md:grid-cols-12 gap-12">
      <div className="md:col-span-5">
        <Logo className="h-14" testId="footer-logo" variant="onDark" />
        <p className="text-white/60 text-sm leading-relaxed max-w-sm mt-6">{COPY.tagline} {COPY.heroLine}</p>
        {COMPANY.appointmentOnly && (
          <p className="inline-flex items-center gap-2 text-xs text-white/70 border border-white/10 rounded-full px-4 py-2 mt-6" data-testid="footer-appointment-note">
            <CalendarCheck size={14} className="text-brand" /> Besichtigung nach Terminvereinbarung
          </p>
        )}
      </div>
      <div className="md:col-span-3">
        <p className="text-[11px] uppercase tracking-[0.25em] text-white/40 mb-5">Navigation</p>
        <ul className="space-y-3 text-sm">
          {nav.map(([to, label]) => (
            <li key={to}><Link to={to} className="text-white/70 hover:text-white transition-colors">{label}</Link></li>
          ))}
        </ul>
      </div>
      <div className="md:col-span-4">
        <p className="text-[11px] uppercase tracking-[0.25em] text-white/40 mb-5">Verkaufsstandort</p>
        <ul className="space-y-3.5 text-sm text-white/70" data-testid="footer-contact">
          <li className="flex gap-3"><MapPin size={16} className="text-brand shrink-0 mt-0.5" />
            <span>{COMPANY.legalName}<br />{COMPANY.street}<br />{COMPANY.city}{COMPANY.countryCode !== "DE" ? `, ${COMPANY.country}` : ""}</span></li>
          <li className="flex gap-3"><Phone size={16} className="text-brand shrink-0 mt-0.5" />
            <a href={COMPANY.phoneLink} className="hover:text-white transition-colors" data-testid="footer-phone-link">{COMPANY.phone}</a></li>
          <li className="flex gap-3"><WaIcon size={16} className="text-brand shrink-0 mt-0.5" />
            <a href={waLink()} target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors" data-testid="footer-whatsapp-link">WhatsApp {COMPANY.phone}</a></li>
          <li className="flex gap-3"><Mail size={16} className="text-brand shrink-0 mt-0.5" />
            <a href={`mailto:${COMPANY.email}`} className="hover:text-white transition-colors" data-testid="footer-email-link">{COMPANY.email}</a></li>
          {COMPANY.instagram && (
            <li className="flex gap-3"><Instagram size={16} strokeWidth={1.8} className="text-brand shrink-0 mt-0.5" />
              <a href={COMPANY.instagram.url} target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors"
                data-testid="footer-company-instagram-link">{COMPANY.instagram.handle}</a></li>
          )}
        </ul>
      </div>
    </div>
    <div className="border-t border-white/10">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-6 grid grid-cols-1 sm:grid-cols-3 items-center gap-3 text-xs text-white/40">
        <p data-testid="footer-copyright">© {COMPANY.since || new Date().getFullYear()} {COMPANY.legalName}</p>
        <span className="flex items-center justify-start sm:justify-center gap-3">
          <a href="https://cloudservice.hr" target="_blank" rel="noopener noreferrer" data-testid="footer-developer-link"
            className="hover:text-white transition-colors">Entwickelt von cloudservice.hr</a>
          <a href="https://www.instagram.com/cloudservice.hr" target="_blank" rel="noopener noreferrer"
            data-testid="footer-instagram-link" aria-label="cloudservice.hr auf Instagram" className="hover:text-white transition-colors">
            <Instagram size={14} strokeWidth={1.8} />
          </a>
        </span>
        <div className="flex flex-wrap items-center gap-6 sm:justify-end">
          <Link to="/impressum" data-testid="footer-impressum-link" className="hover:text-white transition-colors">Impressum</Link>
          <Link to="/datenschutz" data-testid="footer-datenschutz-link" className="hover:text-white transition-colors">Datenschutz</Link>
          <Link to="/admin" data-testid="footer-admin-link" className="hover:text-white transition-colors">Admin</Link>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
